import CartBlock from './CartContainer';
customElements.define('cart-block', CartBlock,{extends: 'div'});

import AddPromotionBlock from './components/promotion/add-promotion';
customElements.define('add-promotion-block', AddPromotionBlock,{extends: 'div'});

import RemovePromotionBtn from './components/promotion/remove-promotion';
customElements.define('remove-promotion-btn', RemovePromotionBtn,{extends: 'a'});

import CheckCGV from './components/cgv/check-cgv';
customElements.define('check-cgv', CheckCGV,{extends: 'div'});

import ShippingMeansSelector from './components/shipping-means/shipping-means';
customElements.define('shipping-means-selector', ShippingMeansSelector,{extends: 'div'});

import SelectAddressItem from './components/addresses/select-address';
customElements.define('select-address-item', SelectAddressItem,{extends: 'div'});

import CreateAddressItem from './components/addresses/create-address';
customElements.define('create-address-item', CreateAddressItem,{extends: 'div'});

import AddToCart from "./components/cart/add-to-cart";
customElements.define('add-to-cart', AddToCart,{extends: 'button'});

import CartLineQuantityUpdator from "./components/cart/cart-line-quantity-updator";
customElements.define('cart-line-quantity-updator', CartLineQuantityUpdator,{extends: 'input'});

import CartLineDeletor from "./components/cart/cart-line-deletor";
customElements.define('cart-line-deletor', CartLineDeletor,{extends: 'button'});
